// eslint-disable-next-line import/prefer-default-export
export const UPDATE_SAVING_STATUS = 'savingTypes/UPDATE_SAVING_STATUS';
